import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function Button({
  className = '',
  variant = 'primary',
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const variantClass = variant === 'secondary' ? 'btn-secondary' : 'btn-primary';
  return <button className={`btn-base ${variantClass} ${className}`} style={fullWidth ? undefined : {
    width: 'auto'
  }} {...props} data-id="element-84">
      {children}
    </button>;
}